const $ = require('jquery');
window.sa = require('./scout_analytics');
const { install, gtag } = require('./ga');
const AuthController = require('./../common/contollers/authController');

const analytics = {

  init: function() {
    this.authContoller = new AuthController();
    this.detectParams();
    this.track('pageview');
    this.listeners();
    install(this.checkGaPageView(), true, true);
  },

  checkGaPageView: function () {
    this.pageviewException = ['/extension/pricing/', '/extension/cn/pricing/'];
    const location = window.location.pathname;

    if (this.pageviewException.includes(location) || this.pageviewException.includes(`${location}/`)) {
      return true;
    }
  },

  detectParams: function () {
    const params = new URL(window.location.href).searchParams;
    this.software = params.get("software") || 'LANDING';
    this.iframe = params.get("iframe");
    this.iframeCategory = this.software !== 'LANDING' ? '_iframe' : '';
  },

  checkPageViewExceptions: function () {
    let result = false;
    ['checkout', 'upgrade', 'pricing'].forEach(e => {
      if (document.location.pathname.includes(e)) {
        result = true;
      }
    });
    return result;
  },

  getUidForExceptionEvent: function () {
    this.uid = this.authContoller.checkLocal();
    return new Promise((res, rej) => {
      if (!this.uid) {
        this.authContoller.sendRequest()
          .then(data => {
            this.authContoller.saveInLocal(data.hash, data.id);
            res(data.id);
          })
          .catch(() => {
            rej("Undefined User");
          });
      } else {
        res(this.uid);
      }
    })
  },

  track: function(category, action, label, value, software, cb, err) {
    if (category.toLowerCase() !== 'pageview') {
      category += analytics.iframeCategory;
      return sa(category, action, label, value, software || analytics.software).then(cb, err);
    } else if (this.checkPageViewExceptions()) {
       function sendViewWithPageSpeedInValue () {
          if (document.location.pathname.includes('checkout')) {
            if (window.performance.timing.loadEventEnd === 0) {
              return window.setTimeout(() => sendViewWithPageSpeedInValue(), 500)
            } else {
              return sa('view', document.location.pathname, document.referrer.split('?')[0], window.performance.timing.loadEventEnd - window.performance.timing.navigationStart, analytics.software);
            }
          } else {
            const simpleEvent = (id = null) => sa('view', document.location.pathname, document.referrer.split('?')[0], value, analytics.software, id);
            if (document.location.pathname.includes('extension') && document.location.pathname.includes('pricing')) {
              analytics.getUidForExceptionEvent()
                .then(id => {
                  return simpleEvent(id);
                })
                .catch(e => {
                  console.warn(e);
                  return simpleEvent();
                });
            } else {
              return simpleEvent();
            }
          }
      }
      window.addEventListener("load", () => {
        sendViewWithPageSpeedInValue();
      });
    }
  },

  trackGa: function(action, category, label, value = '', transport = 'beacon', software) {
    gtag('event', action, {'event_category': `${software || analytics.software}|${category}${analytics.iframeCategory}`, 'event_label': label, 'value': value, 'transport_type': transport});
  },

  trackEventFromExt: function() {
    const params = new URL(window.location.href).searchParams;
    const software = params.get("software");
    const category = params.get("ec");
    const action = params.get("ea");
    const label = params.get("el") || "";

    if (category && action && software) {
      analytics.trackGa(action, category, label);
      analytics.track(category, action, label, null, software);
    }
  },

  sendDoubleEvents: function(event, action, category, label, blank, redirect = true) {
    const url = event.target.href;
    event.preventDefault();
    (async () => {
      await analytics.track(category, action, label);
      await analytics.trackGa(action, category, label);
      if (redirect) {
        const redirectUrl = url.includes("http") ? url : `${$HOST}${url}`;
        blank ? window.open(url, '_blank').focus() : window.parent.location.href = redirectUrl;
      }
    })();
  },

  listeners: function() {
    $('[data-event-category]').each(function (i, e) {
      let $e = $(e);
      let eventtype = $e.attr('data-event-type');
      let category = $e.attr('data-event-category');
      let action = $e.attr('data-event-action');
      let label = $e.attr('data-event-label') || $e.attr('href').split('&url=')[0];
      let link = $e.attr('href');
      let gaCategory = ['MainMenu CTA', 'Index', 'Footer', 'WebAppLP', 'FbaFeeCalculatorLP', 'StockStatsLP', 'BundlesLP', 'AllInOneAmazonStarterBundleOneLP', 'AmazonSellerToolsProLP', 'ChristmasLP', 'WebAppAndExtensionProToolKitLP', 'CNIndex', 'CNPricingLP', 'CoursesPageLP', 'KeywordTrackerLP', 'ToolsLP', 'WebinarsLP', 'SalesEtimatorLP'];
      let gaMenuLinks = ['SCOUT_EXT_PRO', 'SCOUT_EXT_PRO_NEW', 'WEB', 'QUICK_VIEW_EXT', 'KW_TRACKER_EXT', 'STOCK_STATS_EXT', 'CALC_EXT', 'eBayCompare', ' SalesEstimator'];
      let software =  analytics.software;
      let location = window.location.pathname;

      $e.on(eventtype || 'click', function (event) {
        event.preventDefault();
        let gaSend = true;
        analytics.track(category, action, label);
        if (gaCategory.includes(category)) {
          switch (category) {
            case 'MainMenu CTA':
              let clearLink = link.replace('/api/go?url=', '');
              if (link.includes('/app/#/auth/login')) {
                link = 'WEB';
              } else if (gaMenuLinks.includes(clearLink)) {
                link = clearLink;
              } else if (label == 'Amazon to Ebay Compare') { //exception
                link = 'eBayCompare';
              } else if (label == 'Sales Estimator') { //exception
                link = 'SalesEstimator';
              } else {
                gaSend = false;
              }
              label = location;
              action = link;
              break;
            case 'Footer':
              category = 'Footer';
              break;
            default:
              category = 'Page CTA';
              action = link;
              label = location;
              break;
          }
          gaSend && analytics.trackGa(action, category, label, null)
        }
        if (!$(this).parent().hasClass("scroll") && $(this).prop("tagName") == "A") {
          const checkoutPage = window.location.pathname.includes("/checkout");
          const pricingPage = window.location.pathname.includes("/pricing");
          if ((checkoutPage || pricingPage) && ($(this).parent().hasClass('cn_link')) || $(this).parent().hasClass('cn_link_mob')) {
            if ($(this).text() === "简体中文") {
              window.location.pathname = checkoutPage ? "/cn/checkout/" : "/cn/pricing/";
            } else if ($(this).text() === "English") {
              window.location.pathname = checkoutPage ? "/checkout/" : "/pro-ext/pricing";
            }
          } else {
            $(this).attr("target") !== "_blank" ? window.open($(this).attr("href"), '_self') : window.open($(this).attr("href"), '_blank').focus();
          }
        }
      });
    });

    const signEl = $('#sign');
    const path = '/app/';
    const afterTrack = () => window.open(path, '_self');
    signEl.on('click', () => {
      const category = signEl.attr('data-sign-category');
      this.track(category, signEl.attr('data-sign-action'),
        path, undefined, undefined, afterTrack, afterTrack);
      this.trackGa('WEB', category, window.location.pathname);
    });
  }
}

analytics.init();

module.exports = {
  track: analytics.track, trackGa: analytics.trackGa,
  sendDoubleEvents: analytics.sendDoubleEvents,
  trackEventFromExt: analytics.trackEventFromExt
};
